import React, { useEffect, useMemo, useState } from "react";
import { CardContainer } from "../../../components/Card/CardContainer";
import Text from "../../../components/Text/Text";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import {
  Avatar,
  Card,
  Col,
  ConfigProvider,
  Divider,
  Flex,
  Input,
  Modal,
  Progress,
  Row,
  Select,
  Switch,
  Table,
  Tabs,
  Tag,
  Typography,
  Image,
} from "antd";
import Button from "../../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  EyeFilled,
  EyeInvisibleFilled,
  FormOutlined,
  LinkOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  getCoDiscountHistoryById,
  getDetailAdjustById,
  getDetailCoDiscountById,
  getDetailHistoryById,
  getDetailProductById,
  getDetailShopById,
  updateStatusMainWithRemark,
  updateStatusShopWithRemark,
} from "../../../datasource/CODiscountDatasource";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { color, image } from "../../../resource";
import { numberFormatter } from "../../../utility/Formatter";
import { useEffectOnce } from "react-use";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import "./../CODiscountClass.css";
import _ from "lodash";
import { checkCoDuplicate } from "./CreateCODiscountList";
import { useMessageContext } from "../../../context/MessageProvider";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { getProductCategory, getProductGroup } from "../../../datasource/ProductDatasource";
import {
  ChangeStatusShopModal,
  ConfirmChangeStatusModal,
  DetailDuplicateModal,
  ModalPreviewFile,
  useInvoiceExpandable,
} from "../CODiscountComponent";
import Permission from "../../../components/Permission/Permission";
import { ActionBtn } from "../../../components/Button/TableActionButton";
import { FixedType } from "rc-table/lib/interface";
import { mapStatus } from "./IndexCODiscountList";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DetailCODiscountList: React.FC = () => {
  const { messageApi } = useMessageContext();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[pathSplit.length - 2];
  const navigateType = pathSplit[pathSplit.length - 1];

  const [data, setData] = useState<any>(null);
  const [zoneList, setZoneList] = useState<any>([]);
  const [dataHistory, setDataHistory] = useState<any>(null);
  const [productGroup, setProductGroup] = useState<any>([]);
  const [productCategory, setProductCategory] = useState<any>([]);
  const [subTab, setSubTab] = useState<string>("detailShop");
  const [detailShop, setDetailShop] = useState<any>(null);
  const [detailProduct, setDetailProduct] = useState<any>(null);
  const [detailHistory, setDetailHistory] = useState<any>(null);
  const [detailAdjust, setDetailAdjust] = useState<any>(null);
  const historyExpandable = useInvoiceExpandable(profile.company);

  const [modalDuplicate, setModalDuplicate] = useState<any>({
    data: [],
    open: false,
    isStatus: false,
  });
  const [modalChangeStatus, setModalChangeStatus] = useState<any>({
    open: false,
    status: "",
    cusName: "",
    isShowDealer: false,
    coShopId: "",
  });
  const [modalConfirmDup, setModalConfirmDup] = useState<any>({
    open: false,
    data: [],
    isStatus: false,
    isBlocking: false,
    countShop: 0,
    countBlocking: 0,
  });

  const [page, setPage] = useState<number>(1);
  const [pageHistory, setPageHistory] = useState<number>(1);
  const [searchRangePrice, setSearchRangePrice] = useState<
    { min: number; max: number } | undefined
  >(undefined);
  const [searchText, setSearchText] = useState<any>();
  const [searchZone, setSearchZone] = useState<any>();
  const [searchTypeAdjustment, setSearchTypeAdjustment] = useState<any>();
  const [searchProductGroup, setSearchProductGroup] = useState<any>();
  const [searchStrategyGroup, setSearchStrategyGroup] = useState<any>();

  const [openPdf, setOpenPdf] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(profile.company).then((res) => {
      setZoneList(res);
    });
  };
  const fetchDetailCoById = async () => {
    getDetailCoDiscountById(id).then((res: any) => {
      setData(res);
    });
  };
  const fetchProductGroup = async () => {
    await getProductGroup(profile.company).then((res) => {
      setProductGroup(res?.responseData);
    });
  };
  const fetchProductCategory = async () => {
    await getProductCategory(profile.company).then((res) => {
      setProductCategory(res);
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchDetailCoById();
    fetchProductGroup();
    fetchProductCategory();
  });

  const fetchDetailShop = () => {
    getDetailShopById({
      coId: id,
      page,
      take: 10,
      amountMin: searchRangePrice?.min,
      amountMax: searchRangePrice?.max,
      search: searchText,
      zone: searchZone,
    }).then(async (res: any) => {
      const selectedShopIds = res?.data?.map((item: any) => Number(item.customerCompanyId));
      const selectProductIds = data?.coProducts.map((item: any) => String(item.productId)) || [];
      const checkDup =
        (await checkCoDuplicate(
          profile?.company,
          data?.type,
          data?.startDate,
          data?.endDate,
          selectedShopIds,
          selectProductIds,
          data?.coId,
        )) || [];
      if (checkDup?.conflictCoList?.length > 0) {
        const mapShop = res?.data.map((item: any) => {
          const findDup = checkDup?.conflictCoList?.filter((p) =>
            p.shops.some(
              (dupShop: any) => `${dupShop.customerCompanyId}` === `${item.customerCompanyId}`,
            ),
          );
          if (findDup) {
            return {
              ...item,
              status: findDup.some((dup: any) => dup.blocking) ? false : item.status,
              isDuplicate: findDup.length > 0,
              isSwitchDisabled: findDup.some((dup: any) => dup.blocking),
              coDuplicateList: findDup.map((dup: any) => ({
                coId: dup.coId,
                code: dup.code,
                name: dup.name,
                type: dup.type,
                startDate: dup.startDate,
                endDate: dup.endDate,
                products: dup.products,
                creditMemoType: dup.creditMemoType,
                blocking: dup.blocking,
                shops: dup.shops.find(
                  (dupShop: any) => `${dupShop.customerCompanyId}` === `${item.customerCompanyId}`,
                ),
              })),
            };
          } else {
            return {
              ...item,
              isSwitchDisabled: false,
              coDuplicateList: [
                {
                  blocking: false,
                  shops: {
                    customerCompanyId: item.customerCompanyId,
                    customerName: item.customerName,
                  },
                },
              ],
            };
          }
        });
        setDetailShop({ ...res, data: mapShop });
      } else {
        setDetailShop({
          ...res,
          data: res?.data?.map((item: any) => ({
            ...item,
            isSwitchDisabled: false,
            // coDuplicateList: [
            //   {
            //     blocking: false,
            //     shops: {
            //       customerCompanyId: item.customerCompanyId,
            //       customerName: item.customerName,
            //     },
            //   },
            // ],
          })),
        });
      }
    });
  };

  const fetchCoHistory = async () => {
    getCoDiscountHistoryById({ coId: id, page: pageHistory, take: 10 }).then((res: any) => {
      setDataHistory(res);
    });
  };

  useEffect(() => {
    setLoading(true);
    if (subTab === "detailShop") {
      fetchDetailShop();
    } else if (subTab === "detailProduct") {
      getDetailProductById({
        coId: id,
        page,
        take: 10,
        search: searchText,
        productGroup: searchProductGroup,
        strategyGroup: searchStrategyGroup,
      }).then((res: any) => {
        setDetailProduct(res);
      });
    } else if (subTab === "detailHistory") {
      getDetailHistoryById({ coId: id, page, take: 10, search: searchText, zone: searchZone }).then(
        (res: any) => {
          const mapData = res.data.map((item: any) => ({
            ...item,
            rowKey: `${item.customerNo}-${item.orderNo}`,
          }));
          setDetailHistory({ ...res, data: mapData });
        },
      );
    } else if (subTab === "detailAdjust") {
      getDetailAdjustById({
        coId: id,
        page,
        take: 10,
        search: searchText,
        type: searchTypeAdjustment,
      }).then((res: any) => {
        setDetailAdjust(res);
      });
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [
    subTab,
    data,
    page,
    searchRangePrice,
    searchText,
    searchZone,
    searchTypeAdjustment,
    searchProductGroup,
    searchStrategyGroup,
  ]);

  useEffect(() => {
    fetchCoHistory();
  }, [pageHistory]);

  const onChangeStatusMainNoRemark = async (checked: boolean) => {
    const payload = {
      coId: id,
      status: checked ? "ACTIVE" : "INACTIVE",
      saleRemarkText: undefined,
      dealerRemarkText: undefined,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };
    updateStatusMainWithRemark(payload).then((res) => {
      if (res.success) {
        messageApi.success(`เปลี่ยนสถานะสำเร็จ`);
        fetchDetailCoById();
      }
    });
  };

  const onChangeStatusShopNoRemark = async (coShopId: string, checked: boolean) => {
    const payload = {
      coId: id,
      coShopId: coShopId,
      status: checked ? "ACTIVE" : "INACTIVE",
      saleRemarkText: undefined,
      dealerRemarkText: undefined,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };
    await updateStatusShopWithRemark(payload).then((res) => {
      if (res.success) {
        messageApi.success(`เปลี่ยนสถานะสำเร็จ`);
        fetchDetailShop();
      }
    });
  };

  const PageTitle = () => {
    return (
      <PageTitleNested
        title='รายละเอียดรายการส่วนลด'
        showBack
        onBack={() => navigate(-1)}
        extra={
          <>
            {data?.status !== "EXPIRED" ? (
              <Row gutter={16} align='middle'>
                <Col>
                  <Card
                    bodyStyle={{
                      padding: "12px 18px",
                      height: 40,
                      alignItems: "center",
                      display: "flex",
                    }}
                    style={{
                      borderRadius: 14,
                      border: "1px solid #D9DDE5",
                    }}
                  >
                    <Flex align='center' justify='space-between' gap={8}>
                      <Text>
                        {data?.status === "ACTIVE" ? "เปิดใช้งานส่วนลด" : "ปิดใช้งานส่วนลด"}
                      </Text>
                      <Switch
                        checked={data?.status === "ACTIVE"}
                        onChange={(checked) => {
                          const calDateStart = dayjs
                            .utc(data?.startDate)
                            .tz("Asia/Bangkok")
                            .diff(dayjs().tz("Asia/Bangkok"), "minute");

                          if (checked && calDateStart < 0) {
                            const mapList: any = [];
                            const findDup = detailShop?.data.map((p: any, index: number) => {
                              if (p?.coDuplicateList) {
                                mapList.push(...p.coDuplicateList);
                              }
                            });

                            const findShopBlocking = _.groupBy(
                              mapList
                                .filter((item: any) => item?.blocking)
                                .map((item: any) => item?.shops?.customerCompanyId),
                            );
                            const countBlocking = mapList.filter(
                              (item: any) => item?.blocking,
                            ).length;

                            if (checked) {
                              if (
                                (countBlocking !== detailShop?.data?.length &&
                                  mapList.length > 0) ||
                                Object.keys(findShopBlocking)?.length > 0
                              ) {
                                setModalConfirmDup({
                                  open: true,
                                  data: mapList,
                                  isStatus: checked ? "เปิดใช้งาน" : "ปิดใช้งาน",
                                  isBlocking: Object.keys(findShopBlocking)?.length > 0,
                                  countShop: detailShop?.data?.length,
                                  countBlocking: Object.keys(findShopBlocking)?.length,
                                });
                              } else {
                                Modal.confirm({
                                  width: 480,
                                  centered: true,
                                  icon: null,
                                  content: (
                                    <>
                                      <Text level={2} fontWeight={600}>
                                        {checked
                                          ? "เปิดใช้งานรายการส่วนลด"
                                          : "ปิดใช้งานรายการส่วนลด"}
                                      </Text>
                                      <br />
                                      <Text color='Text3'>
                                        โปรดยืนยันการ{checked ? "เปิดใช้งาน" : "ปิดใช้งาน"}{" "}
                                        ส่วนลดดูแลราคาทุกร้านค้า
                                      </Text>
                                      <Divider size='small' />
                                    </>
                                  ),
                                  okText: "ยืนยัน",
                                  cancelText: "ยกเลิก",
                                  cancelButtonProps: {
                                    style: { color: color.primary, borderColor: color.primary },
                                  },
                                  onOk: async () => {
                                    onChangeStatusMainNoRemark(checked);
                                  },
                                });
                              }
                            }
                          } else {
                            setModalChangeStatus({
                              open: true,
                              status: checked ? "เปิดใช้งาน" : "ปิดใช้งาน",
                              cusName: data?.name,
                              isShowDealer: data?.visibleToDealer,
                            });
                          }
                        }}
                      />
                    </Flex>
                  </Card>
                </Col>
                <Col>
                  <Button
                    icon={<FormOutlined />}
                    type='primary'
                    title={"แก้ไขรายละเอียด"}
                    height={40}
                    onClick={() => navigate(`/newDiscountCo/coDiscountList/${id}/detail`)}
                  />
                </Col>
              </Row>
            ) : null}
          </>
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text:
                  navigateType === "coType"
                    ? "ประเภทส่วนลด"
                    : navigateType === "coEachShop"
                      ? "ส่วนลดรายร้านค้า"
                      : navigateType === "coDashboard"
                        ? "แดชบอร์ดส่วนลด"
                        : "รายการส่วนลด",
                path: -1,
              },
              {
                text: "รายละเอียดรายการส่วนลด",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
    );
  };

  const ProgressCard = () => {
    return (
      <Card
        bodyStyle={{
          padding: "12px ",
          alignItems: "center",
          backgroundColor: "#FAFAFA",
        }}
      >
        <Row justify={"space-between"} gutter={8} align='middle'>
          <Col>
            <Row justify={"start"} gutter={8} align='middle'>
              <Col>
                <Tag
                  color={data?.creditMemoType?.color}
                  style={{
                    backgroundColor: `${data?.creditMemoType?.color}20`,
                    borderRadius: "4px",
                  }}
                >
                  <Typography.Text
                    style={{
                      color: data?.creditMemoType?.color,
                      fontFamily: "IBM Plex Sans Thai",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    {data?.creditMemoType?.nameTh}
                  </Typography.Text>
                </Tag>
              </Col>
              <Col>
                <Tag style={{ backgroundColor: "#EEF6FE", borderRadius: "4px", border: "none" }}>
                  <Typography.Text
                    style={{
                      color: "#0068F4",
                      fontFamily: "IBM Plex Sans Thai",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    {data?.type === "BILL_PCT" ? "% ของยอดบิล" : "บาท (฿) / หน่วย"}
                  </Typography.Text>
                </Tag>
              </Col>
              <Col>
                <Tag
                  style={{
                    backgroundColor: mapStatus(data?.viewStatus)?.bgColor,
                    border: "none",
                  }}
                >
                  <Text style={{ color: mapStatus(data?.viewStatus)?.textColor }} fontWeight={600}>
                    {mapStatus(data?.viewStatus)?.text}{" "}
                    {data?.daysToExpiry <= 7 && data?.viewStatus.includes("NEAR")
                      ? `(${data?.daysToExpiry} วัน)`
                      : ""}
                    {dayjs
                      .utc(data?.startDate)
                      .tz("Asia/Bangkok")
                      .diff(dayjs().tz("Asia/Bangkok"), "minute") > 0 &&
                    data?.viewStatus === "ACTIVE"
                      ? `(รอเริ่ม)`
                      : ""}
                  </Text>
                </Tag>
              </Col>
              <Col>
                <Tag
                  style={{
                    backgroundColor: data?.visibleToDealer ? "#E2FDEB" : "#F0F0F0",
                    borderRadius: "4px",
                    border: "none",
                  }}
                >
                  <Typography.Text
                    style={{
                      color: data?.visibleToDealer ? "#3A9757" : color.Grey,
                      fontFamily: "IBM Plex Sans Thai",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    <>{data?.visibleToDealer ? <EyeFilled /> : <EyeInvisibleFilled />}</>{" "}
                    {data?.visibleToDealer ? "แสดงให้ Dealer เห็น" : "ไม่แสดงให้ Dealer เห็น"}
                  </Typography.Text>
                </Tag>
              </Col>
            </Row>
          </Col>
          <Col>
            <Text>{`ระยะเวลา ${dayjs(data?.startDate).format("DD/MM/YYYY, HH:mm")} - ${dayjs(data?.endDate).format("DD/MM/YYYY, HH:mm")}`}</Text>
          </Col>
        </Row>
        <br />
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            {data?.name}
          </span>
        </div>
        <Progress
          percent={data?.used && data?.totalDiscount ? (data?.used / data?.totalDiscount) * 100 : 0}
          style={{ width: "100%" }}
          percentPosition={{ align: "end", type: "inner" }}
          size={["default", 20]}
          strokeColor={data?.creditMemoType?.color}
          format={(percent) => (
            <Text level={6} color='white' fontWeight={600}>
              {data?.used && data?.totalDiscount
                ? numberFormatter((data?.used / data?.totalDiscount) * 100)
                : 0}
              %
            </Text>
          )}
        />
        <Row justify={"space-between"} gutter={8} align='middle' style={{ paddingTop: "5px" }}>
          <Col>
            <Text>ใช้ไป {numberFormatter(data?.used)} ฿</Text>
          </Col>
          <Col>
            <Text fontWeight={600}>
              คงเหลือ {numberFormatter(data?.remaining)} / {numberFormatter(data?.totalDiscount)} ฿
            </Text>
          </Col>
        </Row>
      </Card>
    );
  };

  const rangePrice = [
    { label: "0-50,000", value: 1, key: 1, min: 0, max: 50000 },
    { label: "50,000-100,000", value: 2, key: 2, min: 50000, max: 100000 },
    { label: "100,000-200,000", value: 3, key: 3, min: 100000, max: 200000 },
    { label: "200,000-300,000", value: 4, key: 4, min: 200000, max: 300000 },
    { label: "300,000-400,000", value: 5, key: 5, min: 300000, max: 400000 },
    { label: "400,000-500,000", value: 6, key: 6, min: 400000, max: 500000 },
    { label: "มากกว่า 500,000", value: 7, key: 7, min: 500000, max: undefined },
  ];

  const TabDetail = () => {
    const dataRender = [
      { label: "สถานะ", value: data?.status === "ACTIVE" ? "เปิดใช้งาน" : "ปิดใช้งาน" },
      { label: "รหัสส่วนลด", value: data?.code },
      { label: "ชื่อรายการ", value: data?.name },
      { label: "ประเภทส่วนลด", value: data?.creditMemoType?.nameTh },
      {
        label: "วิธีคิดส่วนลด",
        value: data?.type === "BILL_PCT" ? "% ของยอดบิล" : "บาท (฿) / หน่วย",
      },
      {
        label: "ระยะเวลาใช้ส่วนลด",
        value: `${dayjs(data?.startDate).format("DD/MM/YYYY, HH:mm")} - ${dayjs(data?.endDate).format("DD/MM/YYYY, HH:mm")}`,
      },
      {
        label: "ไฟล์ส่วนลดดูแลราคา",
        value: data?.attachmentUrl,
      },
      {
        label: "แสดงให้ Dealer เห็น",
        value: data?.visibleToDealer ? "แสดง" : "ไม่แสดง",
      },
      {
        label: "อัปเดทโดย",
        value: data?.updatedBy || data?.createdBy || "-",
      },
      {
        label: "หมายเหตุเพิ่มเติม",
        value: data?.description ? data?.description : "-",
      },
    ];

    const ShopTab = () => {
      const columnShop: any = [
        {
          title: "ชื่อร้านค้า",
          dataIndex: "customerName",
          key: "customerName",
          width: "20%",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value}</Text>
                  <Text color='Text3' level={6}>
                    {row.customerNo} • เขต {row.zone}
                  </Text>
                  {row.isDuplicate && (
                    <Row key={row?.coShopId}>
                      <Text level={6} color={row?.isSwitchDisabled ? "error" : "warning"}>
                        ร้านนี้มีสินค้าที่ซ้ำกับส่วนลดอื่น
                      </Text>
                      &nbsp;&nbsp;
                      <Text
                        level={6}
                        color={row?.isSwitchDisabled ? "error" : "warning"}
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalDuplicate({ data: row.coDuplicateList, open: true })}
                      >
                        <u>ดูเพิ่มเติม</u>
                      </Text>
                    </Row>
                  )}
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "% ของยอดบิล",
          dataIndex: "discountPct",
          key: "discountPct",
          align: "center",
          hidden: data?.type === "BILL_PCT" ? false : true,
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text>{numberFormatter(value)} %</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ส่วนลด",
          dataIndex: "quotaAmount",
          key: "quotaAmount",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text>{numberFormatter(value)}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ใช้ไป",
          dataIndex: "quotaUsed",
          key: "quotaUsed",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text color={value > 0 ? "error" : "Text1"}>
                    {value > 0 ? `-${numberFormatter(value)}` : numberFormatter(value)} ฿
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "คงเหลือ",
          dataIndex: "quotaRemaining",
          key: "quotaRemaining",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text color='EmeraldGreen'>{numberFormatter(value)} ฿</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "สถานะ",
          dataIndex: "status",
          key: "status",
          align: "center",
          render: (value: any, row: any, index: number) => {
            const calDateStart = dayjs
              .utc(row?.startDate)
              .tz("Asia/Bangkok")
              .diff(dayjs().tz("Asia/Bangkok"), "minute");
            return {
              children: (
                <>
                  {value === "EXPIRED" ? (
                    <Tag
                      style={{
                        backgroundColor: value === "ACTIVE" ? "#E2FDEB" : "#F0F0F0",
                        borderRadius: "4px",
                        border: "none",
                      }}
                    >
                      <Typography.Text
                        style={{
                          color: value === "ACTIVE" ? "#3A9757" : color.Grey,
                          fontFamily: "IBM Plex Sans Thai",
                          fontWeight: 600,
                          fontSize: 14,
                        }}
                      >
                        {value === "ACTIVE" ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                      </Typography.Text>
                    </Tag>
                  ) : (
                    <FlexCol style={{ alignItems: "center" }}>
                      <Switch
                        checked={value === "ACTIVE"}
                        disabled={row?.isSwitchDisabled}
                        onChange={async (checked) => {
                          if (!checked && calDateStart <= 0) {
                            setModalChangeStatus({
                              open: true,
                              status: checked ? "เปิดใช้งาน" : "ปิดใช้งาน",
                              cusName: row.customerName,
                              isShowDealer: data?.visibleToDealer,
                              coShopId: row.coShopId,
                            });
                          } else {
                            Modal.confirm({
                              width: 600,
                              centered: true,
                              icon: null,
                              title: (
                                <Text level={3} fontWeight={600}>
                                  เปิดใช้งานรายการส่วนลด
                                </Text>
                              ),
                              content: (
                                <Text color='Text3'>
                                  โปรดยืนยันการเปิดใช้งานส่วนลดดูแลราคาของ {row.customerName}
                                </Text>
                              ),
                              okText: "ยืนยัน",
                              cancelText: "ยกเลิก",
                              cancelButtonProps: {
                                style: { color: color.primary, borderColor: color.primary },
                              },
                              onOk: async (e) => {
                                onChangeStatusShopNoRemark(row.coShopId, checked);
                              },
                            });
                          }
                        }}
                      />
                    </FlexCol>
                  )}
                </>
              ),
            };
          },
        },
        {
          title: "หมายเหตุถึง Sale",
          dataIndex: "latestSaleRemarkText",
          key: "latestSaleRemarkText",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value || "-"}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "หมายเหตุถึง Dealer",
          dataIndex: "latestDealerRemarkText",
          key: "latestDealerRemarkText",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value || "-"}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ไปที่ร้าน",
          dataIndex: "action",
          key: "action",
          width: "6%",
          align: "center",
          fixed: "right" as FixedType | undefined,
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Permission permission={["coDiscountEachShop", "view"]}>
                    <ActionBtn
                      onClick={() =>
                        navigate(
                          "/newDiscountCo/detailCODiscountEachShop/" +
                            row.customerCompanyId +
                            "/coList",
                        )
                      }
                      icon={<UnorderedListOutlined />}
                    />
                  </Permission>
                </FlexCol>
              ),
            };
          },
        },
      ];

      return (
        <>
          <Row justify={"start"} gutter={8}>
            <Col span={4}>
              <Select
                allowClear
                value={
                  searchRangePrice
                    ? rangePrice.find(
                        (item: any) =>
                          item.min === searchRangePrice.min && item.max === searchRangePrice.max,
                      )?.value
                    : undefined
                }
                options={rangePrice || []}
                placeholder='เลือกช่วงราคาคงเหลือ'
                style={{ width: "100%", height: "40px" }}
                onChange={(value: any) => {
                  setPage(1);
                  const selectedRange: any = rangePrice.find((item: any) => item.value === value);
                  if (selectedRange) {
                    setSearchRangePrice({ min: selectedRange.min, max: selectedRange.max });
                  } else {
                    setSearchRangePrice(undefined);
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                value={searchZone}
                allowClear
                options={
                  zoneList.map((zone: any) => ({
                    label: zone.zoneName,
                    value: zone.zoneName,
                    key: zone.zoneName,
                  })) || []
                }
                onChange={(value: any) => {
                  setPage(1);
                  setSearchZone(value);
                }}
                placeholder='เลือกเขต'
                style={{ width: "100%", height: "40px" }}
              />
            </Col>
            <Col span={6}>
              <Input
                allowClear
                defaultValue={searchText}
                onChange={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  }
                }}
                onPressEnter={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  } else {
                    setSearchText(e.target.value);
                  }
                }}
                suffix={<SearchOutlined />}
                placeholder='ค้นหาร้านค้า'
                style={{ width: "100%", height: "40px" }}
              />
            </Col>
            <Col style={{ paddingTop: "8px" }}>
              <Text color='Text3'>ทั้งหมด {detailShop?.total || 0} ร้านค้า</Text>
            </Col>
          </Row>
          <br />
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  colorTextHeading: "white",
                },
              },
            }}
          >
            <Table
              loading={loading}
              columns={columnShop}
              dataSource={detailShop?.data || []}
              tableLayout='fixed'
              scroll={{
                x: 1500,
              }}
              pagination={{
                showSizeChanger: false,
                total: detailShop?.total,
                current: Number(page),
                position: ["bottomCenter"],
                onChange: (page) => {
                  setPage(page);
                },
              }}
            />
          </ConfigProvider>
        </>
      );
    };

    const ProductTab = () => {
      const columnProduct: any = [
        {
          title: "ชื่อสินค้า",
          dataIndex: "productName",
          key: "productName",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexRow align='center'>
                  <div style={{ marginRight: 16 }}>
                    <Avatar
                      src={
                        row.productImage === "No" ||
                        row.productImage === "" ||
                        row.productImage === null
                          ? image.product_no_image
                          : row.productImage
                      }
                      size={50}
                      shape='square'
                      onError={() => false}
                    />
                  </div>
                  <FlexCol>
                    <div style={{ height: 25, textOverflow: "ellipsis" }}>
                      <Text level={5}>{row.productName}</Text>
                    </div>
                    {row.commonName && (
                      <div style={{ height: 25, textOverflow: "ellipsis" }}>
                        <Text level={6} style={{ color: color.Grey }}>
                          {row.commonName}
                        </Text>
                      </div>
                    )}
                    <div style={{ height: 25 }}>
                      <Text level={6} style={{ color: color.Grey }}>
                        Product Group : {row.productGroup}
                      </Text>
                    </div>
                    {row.productStrategy && (
                      <div style={{ height: 25 }}>
                        <Text level={6} style={{ color: color.Grey }}>
                          Strategy Group : {row.productStrategy}
                        </Text>
                      </div>
                    )}
                  </FlexCol>
                </FlexRow>
              ),
            };
          },
        },
        {
          title: "Product Code",
          dataIndex: "productCodeNAV",
          key: "productCodeNAV",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexRow>
                  <FlexCol>
                    <div style={{ height: 25 }}>
                      <Text level={5}>{value}</Text>
                    </div>
                    <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                      <Text level={6} style={{ color: color.Grey }}>
                        Pack Size : {row.packSize}
                      </Text>
                    </div>
                  </FlexCol>
                </FlexRow>
              ),
            };
          },
        },
        {
          title: "ราคาขาย",
          dataIndex: "marketPrice",
          key: "marketPrice",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexRow>
                  <FlexCol>
                    <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
                      <Text level={5}>
                        {numberFormatter(row.marketPrice)} บาท/{row.saleUOMTH}
                      </Text>
                    </div>
                    {profile.company === "ICPL" && (
                      <div>
                        <Text level={6} style={{ color: color.Grey }}>
                          ราคา/หน่วย : {numberFormatter(value)} บาท/{row.baseUOM || row.saleUOMTH}
                        </Text>
                      </div>
                    )}
                  </FlexCol>
                </FlexRow>
              ),
            };
          },
        },
        {
          title: "ส่วนลด",
          dataIndex: "discountValue",
          key: "discountValue",
          width: "20%",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>
                    {numberFormatter(value)}{" "}
                    {row.discountMode === "BAHT_PER_UNIT" ? "บาท (฿) /" : "% / "}{" "}
                    {row.saleUOMTH || "-"}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
      ];

      return (
        <>
          <Row justify={"start"} gutter={8}>
            <Col span={5}>
              <Input
                allowClear
                suffix={<SearchOutlined />}
                placeholder='ค้นหาชื่อสินค้า'
                style={{ width: "100%", height: "40px" }}
                defaultValue={searchText}
                onChange={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  }
                }}
                onPressEnter={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  } else {
                    setSearchText(e.target.value);
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                defaultValue={searchProductGroup}
                allowClear
                options={
                  productGroup?.map((item) => ({
                    label: item.product_group,
                    value: item.product_group,
                    key: item.product_group,
                  })) || []
                }
                placeholder='Product Group ทั้งหมด'
                style={{ width: "100%", height: "40px" }}
                onChange={(value: any) => {
                  setPage(1);
                  setSearchProductGroup(value);
                }}
              />
            </Col>
            {profile.company === "ICPL" && (
              <Col span={4}>
                <Select
                  defaultValue={searchStrategyGroup}
                  allowClear
                  options={
                    productCategory.map((item) => ({
                      label: item.productCategoryName,
                      value: item.productCategoryId,
                      key: item.productCategoryId,
                    })) || []
                  }
                  placeholder='Strategy Group ทั้งหมด'
                  style={{ width: "100%", height: "40px" }}
                  onChange={(value: any) => {
                    setPage(1);
                    setSearchStrategyGroup(value);
                  }}
                />
              </Col>
            )}
            <Col style={{ paddingTop: "8px" }}>
              <Text color='Text3'>ทั้งหมด {detailProduct?.total || 0} รายการ</Text>
            </Col>
          </Row>
          <br />
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  colorTextHeading: "white",
                },
              },
            }}
          >
            <Table
              loading={loading}
              columns={columnProduct}
              dataSource={detailProduct?.data || []}
              pagination={{
                total: detailProduct?.total,
                current: Number(page),
                position: ["bottomCenter"],
                onChange: (page) => {
                  setPage(page);
                },
              }}
            />
          </ConfigProvider>
        </>
      );
    };

    const HistoryTab = () => {
      const columnHistory: any = [
        {
          title: "วันที่",
          dataIndex: "date",
          key: "date",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text>{dayjs(value).format("DD/MM/YYYY")}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "Sellcoda NO.",
          dataIndex: "orderNo",
          key: "orderNo",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text
                    color='primary'
                    style={{ cursor: "pointer" }}
                    onClick={() => value && window.open(`/order/${row.orderId}`, "_blank")}
                  >
                    {value ? <u>{value}</u> : "-"}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ชื่อร้านค้า",
          dataIndex: "customerName",
          key: "customerName",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value}</Text>
                  <Text color='Text3' level={6}>
                    {row.customerNo} • เขต {row.zone}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "SO",
          dataIndex: "soNo",
          key: "soNo",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text
                    color={value ? "primary" : "Text1"}
                    style={{ cursor: "pointer" }}
                    onClick={() => value && window.open(`/order/${row.orderId}`, "_blank")}
                  >
                    {value ? <u>{value}</u> : "-"}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "จำนวนสินค้ารวม",
          dataIndex: "deducted",
          key: "deducted",
          align: "center",
          hidden: data?.coProducts?.length > 0 ? false : true,
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text>
                    {row.productQuantities.map((pq: any) => pq.quantity + " " + pq.unit).join(", ")}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ยอดที่หัก",
          dataIndex: "deducted",
          key: "deducted",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text color={row.entryType === "REFUND" ? "success" : "error"}>
                    {row.entryType === "REFUND"
                      ? `+${numberFormatter(value)}`
                      : `-${numberFormatter(value)}`}{" "}
                    ฿
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
      ];

      return (
        <>
          <Row justify={"start"} gutter={8}>
            <Col span={8}>
              <Input
                allowClear
                suffix={<SearchOutlined />}
                placeholder='ค้นหาร้านค้า, Sellcoda No., SO No. หรือ Invoice No.'
                style={{ width: "100%", height: "40px" }}
                defaultValue={searchText}
                onChange={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  }
                }}
                onPressEnter={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  } else {
                    setSearchText(e.target.value);
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                value={searchZone}
                allowClear
                options={
                  zoneList.map((zone: any) => ({
                    label: zone.zoneName,
                    value: zone.zoneName,
                    key: zone.zoneName,
                  })) || []
                }
                onChange={(value: any) => {
                  setPage(1);
                  setSearchZone(value);
                }}
                placeholder='เลือกเขต'
                style={{ width: "100%", height: "40px" }}
              />
            </Col>
            <Col style={{ paddingTop: "8px" }}>
              <Text color='Text3'>ทั้งหมด {detailHistory?.total || 0} รายการ</Text>{" "}
              {detailHistory?.totalDeducted > 0 && (
                <Text color='Text3'>
                  • รวมยอดที่หัก{" "}
                  <b style={{ color: "red" }}>
                    -{numberFormatter(detailHistory?.totalDeducted || 0)} ฿
                  </b>
                </Text>
              )}
            </Col>
          </Row>
          <br />
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  colorTextHeading: "white",
                },
              },
            }}
          >
            <Table
              loading={loading}
              rowKey='rowKey'
              columns={columnHistory}
              dataSource={detailHistory?.data || []}
              {...(detailHistory?.data?.some((item: any) => item.invoices?.length > 0) && {
                expandable: historyExpandable,
              })}
              pagination={{
                position: ["bottomCenter"],
              }}
            />
          </ConfigProvider>
        </>
      );
    };

    const AdjustTab = () => {
      const [openImg, setOpenImg] = useState<{ open: boolean; value: string | null }>({
        open: false,
        value: null,
      });

      const columnAdjust: any = [
        {
          title: "วันที่",
          dataIndex: "date",
          key: "date",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text>{dayjs(value).format("DD/MM/YYYY")}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ประเภท",
          dataIndex: "type",
          key: "type",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Tag
                    style={{
                      border: "none",
                      backgroundColor: value.includes("ADD") ? "#F0FDF4" : "#FEECEC",
                    }}
                  >
                    <Text color={value.includes("ADD") ? "success" : "error"} fontWeight={600}>
                      {value.includes("ADD") ? "เพิ่มยอด" : "ลดยอด"}{" "}
                    </Text>
                  </Tag>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ชื่อร้านค้า",
          dataIndex: "customerName",
          key: "customerName",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value}</Text>
                  <Text color='Text3' level={6}>
                    {row.customerNo} • เขต {row.zone}
                  </Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "รายละเอียด",
          dataIndex: "reason",
          key: "reason",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Text>{value}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "จำนวน",
          dataIndex: "signedAmount",
          key: "signedAmount",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "flex-end" }}>
                  <Text color={value > 0 ? "success" : "error"}>{numberFormatter(value)} ฿</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ดูไฟล์แนบ",
          dataIndex: "attachmentUrl",
          key: "attachmentUrl",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  {value ? (
                    <Text
                      color='primary'
                      onClick={() => setOpenImg({ open: true, value: value })}
                      style={{ cursor: "pointer" }}
                    >
                      <LinkOutlined />
                      &nbsp;ดูไฟล์แนบ
                    </Text>
                  ) : (
                    "-"
                  )}
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ดำเนินการโดย",
          dataIndex: "createdBy",
          key: "createdBy",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol style={{ alignItems: "center" }}>
                  <Text>{value}</Text>
                </FlexCol>
              ),
            };
          },
        },
        {
          title: "ไปที่ร้าน",
          dataIndex: "action",
          key: "action",
          width: "6%",
          align: "center",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <FlexCol>
                  <Permission permission={["coDiscountEachShop", "view"]}>
                    <ActionBtn
                      onClick={() =>
                        navigate(
                          "/newDiscountCo/detailCODiscountEachShop/" +
                            row.customerCompanyId +
                            "/coList",
                        )
                      }
                      icon={<UnorderedListOutlined />}
                    />
                  </Permission>
                </FlexCol>
              ),
            };
          },
        },
      ];

      return (
        <>
          <Row justify={"start"} gutter={8}>
            <Col span={8}>
              <Input
                allowClear
                suffix={<SearchOutlined />}
                placeholder='ค้นหาร้านค้า'
                style={{ width: "100%", height: "40px" }}
                defaultValue={searchText}
                onChange={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  }
                }}
                onPressEnter={(e: any) => {
                  setPage(1);
                  if (!e.target.value) {
                    setSearchText(undefined);
                  } else {
                    setSearchText(e.target.value);
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                options={[
                  { label: "เพิ่มลด", value: "ADJUST_ADD", key: "ADJUST_ADD" },
                  { label: "ลดยอด", value: "ADJUST_SUB", key: "ADJUST_SUB" },
                ]}
                style={{ width: "100%", height: "40px" }}
                placeholder='ประเภททั้งหมด'
                value={searchTypeAdjustment}
                onChange={(e) => {
                  setPage(1);
                  setSearchTypeAdjustment(e);
                }}
              />
            </Col>
            <Col span={4}>
              <Select
                value={searchZone}
                allowClear
                options={
                  zoneList.map((zone: any) => ({
                    label: zone.zoneName,
                    value: zone.zoneName,
                    key: zone.zoneName,
                  })) || []
                }
                onChange={(value: any) => {
                  setPage(1);
                  setSearchZone(value);
                }}
                placeholder='เลือกเขต'
                style={{ width: "100%", height: "40px" }}
              />
            </Col>
            <Col style={{ paddingTop: "8px" }}>
              <Text color='Text3'>ทั้งหมด {detailAdjust?.total || 0} รายการ</Text>
            </Col>
          </Row>
          <br />
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#1B4586",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  colorTextHeading: "white",
                },
              },
            }}
          >
            <Table
              loading={loading}
              columns={columnAdjust}
              dataSource={detailAdjust?.data || []}
              pagination={{
                position: ["bottomCenter"],
              }}
            />
          </ConfigProvider>
          {openImg.open && (
            <Image
              style={{ display: "none" }}
              src={openImg.value || undefined}
              preview={{
                visible: openImg.open,
                onVisibleChange: (visible) =>
                  setOpenImg((prev) => ({
                    ...prev,
                    open: visible,
                  })),
              }}
            />
          )}
        </>
      );
    };

    const [seeMore, setSeeMore] = useState(false);

    const tabItems = useMemo(
      () => [
        {
          label: `ส่วนลดต่อร้าน`,
          key: "detailShop",
          children: <ShopTab />,
        },
        ...(data?.coProducts?.length > 0
          ? [
              {
                label: `สินค้าที่เข้าร่วม`,
                key: "detailProduct",
                children: <ProductTab />,
              },
            ]
          : []),
        {
          label: `ประวัติการใช้ `,
          key: "detailHistory",
          children: <HistoryTab />,
        },
        {
          label: `ปรับยอด `,
          key: "detailAdjust",
          children: <AdjustTab />,
        },
      ],
      [detailShop, detailProduct, detailHistory, detailAdjust, searchText, searchRangePrice],
    );

    return (
      <>
        <Card
          bodyStyle={{
            padding: "12px ",
            alignItems: "center",
            backgroundColor: "#FAFAFA",
          }}
        >
          <Row>
            <Col span={12}>
              {dataRender.slice(0, 5).map((item, index) => (
                <Row key={index} gutter={8} style={{ marginBottom: "8px" }}>
                  <Col span={10} key={index}>
                    <Text color='Text3'>{item.label}</Text>
                  </Col>
                  <Col span={14}>
                    <Text>{item.value}</Text>
                  </Col>
                </Row>
              ))}
            </Col>
            <Col span={12}>
              {dataRender.slice(5).map((item, index) => (
                <Row key={index} gutter={8} style={{ marginBottom: "8px" }}>
                  <Col span={10} key={index}>
                    <Text color='Text3'>{item.label}</Text>
                  </Col>
                  <Col span={14}>
                    <>
                      {item.label.includes("ไฟล์") ? (
                        <>
                          {item.value ? (
                            <Text
                              color='primary'
                              onClick={() => setOpenPdf(true)}
                              style={{ cursor: "pointer" }}
                            >
                              <LinkOutlined />
                              &nbsp;ดูไฟล์ส่วนลดดูแลราคา
                            </Text>
                          ) : (
                            "-"
                          )}
                          {openPdf && (
                            <ModalPreviewFile
                              openPdf={openPdf}
                              setOpenPdf={setOpenPdf}
                              fileRef={item.value}
                            />
                          )}
                        </>
                      ) : item.label.includes("หมายเหตุ") ? (
                        <>
                          {!seeMore && (
                            <Text>
                              {item?.value?.length > 85
                                ? `${item?.value?.slice(0, 85)}...`
                                : item?.value || "-"}
                            </Text>
                          )}
                          {seeMore && <Text>{item?.value || "-"}</Text>}{" "}
                          {item?.value?.length > 85 && (
                            <Text
                              color='primary'
                              style={{ cursor: "pointer" }}
                              onClick={() => setSeeMore(!seeMore)}
                            >
                              <u>{seeMore ? "ดูน้อยลง" : "ดูเพิ่มเติม"}</u>
                            </Text>
                          )}
                        </>
                      ) : (
                        <Text>{item.value}</Text>
                      )}
                    </>
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Card>
        <br />
        <Tabs
          onChange={(key) => {
            setSubTab(key);
            setPage(1);
            setSearchText(undefined);
            setSearchRangePrice(undefined);
            setSearchZone(undefined);
            setSearchTypeAdjustment(undefined);
            setSearchProductGroup(undefined);
            setSearchStrategyGroup(undefined);
          }}
          activeKey={subTab}
          style={{ fontFamily: "IBM Plex Sans Thai" }}
          items={tabItems}
        />
        <br />
      </>
    );
  };

  const TabHistory = () => {
    const columns: any = [
      {
        title: "วันที่เวลาที่อัปเดท",
        dataIndex: "changedAt",
        key: "changedAt",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{dayjs(value).format("DD/MM/YYYY HH:mm")}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ผู้ใช้งาน",
        dataIndex: "changedBy",
        key: "changedBy",
        align: "center",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>{value || "-"}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "กิจกรรม",
        dataIndex: "action",
        key: "action",
        align: "center",
        render: (value: any, row: any, index: number) => {
          const mapText: any = {
            CREATE: "สร้าง Credit Memo",
            UPDATE: "แก้ไข Credit Memo",
            STATUS_CHANGE: "เปลี่ยนแปลงสถานะ",
          };
          return {
            children: (
              <FlexRow>
                <Text>{mapText[value]}</Text> &nbsp;
                {value === "CREATE" && <Text>({row.afterData.name || "-"})</Text>}
              </FlexRow>
            ),
          };
        },
      },
      {
        title: "ข้อมูลเดิม",
        dataIndex: "afterValue",
        key: "afterValue",
        align: "center",
        render: (value: any, row: any, index: number) => {
          const mapStatus: any = {
            ACTIVE: "เปิดการใช้งาน",
            INACTIVE: "ปิดการใช้งาน",
          };
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>
                  {row.action === "CREATE"
                    ? "-"
                    : mapStatus[row.beforeData.status] || row.beforeData.name || "-"}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ข้อมูลใหม่",
        dataIndex: "beforeValue",
        key: "beforeValue",
        align: "center",
        render: (value: any, row: any, index: number) => {
          const mapStatus: any = {
            ACTIVE: "เปิดการใช้งาน",
            INACTIVE: "ปิดการใช้งาน",
          };
          return {
            children: (
              <FlexCol style={{ alignItems: "center" }}>
                <Text>
                  {row.action === "CREATE"
                    ? "-"
                    : mapStatus[row.afterData.status] || row.afterData.name || "-"}
                </Text>
              </FlexCol>
            ),
          };
        },
      },
    ];

    return (
      <>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                colorTextHeading: "white",
              },
            },
          }}
        >
          <Table
            columns={columns}
            dataSource={dataHistory?.data || []}
            pagination={{
              position: ["bottomCenter"],
              total: dataHistory?.total,
              current: pageHistory,
              onChange: (page) => setPageHistory(page),
            }}
          />
        </ConfigProvider>
      </>
    );
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <Divider />
        <ProgressCard />
        <br />
        <Tabs
          style={{ fontFamily: "IBM Plex Sans Thai" }}
          items={[
            {
              label: `รายละเอียด ส่วนลดดูแลราคา`,
              key: "detail",
              children: <TabDetail />,
            },
            {
              label: `ประวัติการสร้าง ส่วนลดดูแลราคา`,
              key: "history",
              children: <TabHistory />,
            },
          ]}
        />
      </CardContainer>
      {modalDuplicate.open && (
        <DetailDuplicateModal
          dataDup={modalDuplicate.data}
          open={modalDuplicate.open}
          setOpen={(open) => setModalDuplicate((prev) => ({ ...prev, open }))}
          isStatus={modalDuplicate.isStatus}
          coType={data?.type}
        />
      )}
      {modalChangeStatus.open && (
        <ChangeStatusShopModal
          coId={id}
          coShopId={modalChangeStatus.coShopId}
          open={modalChangeStatus.open}
          status={modalChangeStatus.status}
          cusName={modalChangeStatus.cusName}
          setOpen={(open) => setModalChangeStatus((prev) => ({ ...prev, open }))}
          isShowDealer={modalChangeStatus.isShowDealer}
          fetchData={() => {
            setPage(1);
            fetchDetailShop();
            fetchDetailCoById();
          }}
        />
      )}
      {modalConfirmDup.open && (
        <ConfirmChangeStatusModal
          modalConfirmDup={modalConfirmDup}
          setModalConfirmDup={setModalConfirmDup}
          modalDuplicate={modalDuplicate}
          setModalDuplicate={setModalDuplicate}
          onFinish={() => {
            onChangeStatusMainNoRemark(true);
            setModalConfirmDup((prev) => ({ ...prev, open: false }));
            fetchDetailShop();
          }}
        />
      )}
    </>
  );
};
